import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  height: 300px;

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

const Item = styled.a`
  flex: 1;

  & > iframe { 
    margin: 0;
  }
`;

const Singles = class extends React.Component {
  render() {
    return (
      <div>
        <Container>
          <Item>
            <iframe
              width="100%"
              height="300"
              scrolling="no"
              frameBorder="no"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/551197500&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
            />
          </Item>
          <Item>
            <iframe
              width="100%"
              height="300"
              scrolling="no"
              frameBorder="no"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/576534081&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
            />
          </Item>
          <Item>
            <iframe
              width="100%"
              height="300"
              scrolling="no"
              frameBorder="no"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/474921699&color=%239c9484&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
            />
          </Item>
        </Container>
      </div>
    );
  }
};

export default Singles;



// WEBPACK FOOTER //
// ./src/components/singles.js